import PROFILE_FIELD from "Constants/profileFields";

import { ACCOUNT_TYPE } from "Services/user";
import { PASSWORD } from "Services/profile";

import {
  LOAD_PROFILE_REQUESTED,
  LOAD_PROFILE_OK,
  LOAD_PROFILE_FAIL,
  SET_ACCOUNT_TYPE,
  SET_PROFILE,
  UPDATE_PROFILE_REQUESTED,
  UPDATE_PROFILE_OK,
  UPDATE_PROFILE_FAIL,
  SET_CURRENT_PASSWORD,
  SET_NEW_PASSWORD,
  SET_NEW_CONFIRM_PASSWORD,
  UPDATE_PASSWORD_REQUESTED,
  UPDATE_PASSWORD_OK,
  UPDATE_PASSWORD_FAIL,
} from "actions/profile";

const INITIAL_STATE = {
  loading: false,
  data: {},
  errors: {
    [PROFILE_FIELD.EMAIL]: undefined,
    [PROFILE_FIELD.CITY]: undefined,
    [PROFILE_FIELD.ADDRESS]: undefined,
    [PROFILE_FIELD.MESSENGER]: undefined,
    [PROFILE_FIELD.MESSENGER_TYPE]: undefined,
    [PROFILE_FIELD.PHONE_NUMBER]: undefined,
    [PROFILE_FIELD.IS_AGREE_NEWS_LETTER]: undefined,
    [PROFILE_FIELD.VAT]: undefined,
    [PROFILE_FIELD.LAST_NAME]: undefined,
    [PROFILE_FIELD.FIRST_NAME]: undefined,
    [PROFILE_FIELD.ACCOUNT_TYPE]: undefined,
    [PROFILE_FIELD.COMPANY_NAME]: undefined,
    [PROFILE_FIELD.BENEFICIARY_ID]: undefined,
    [PROFILE_FIELD.RESIDENCE_COUNTRY]: undefined,
    [PROFILE_FIELD.FIRST_NAME]: undefined,
    [PROFILE_FIELD.LAST_NAME]: undefined,
  },
  isUnknownAccountType: true,
  isCompany: false,
  isIndividual: false,
  isPasswordUpdated: false,
  currentPassword: "",
  newPassword: "",
  newConfirmPassword: "",
  passwordErrors: {
    [PASSWORD.CURRENT_PASSWORD]: undefined,
    [PASSWORD.NEW_PASSWORD]: undefined,
    [PASSWORD.NEW_CONFIRM_PASSWORD]: undefined,
  },
  isOurTermsAccepted: true,
};

export function profileReducer(state = INITIAL_STATE, action) {
  switch (action.type) {
    case LOAD_PROFILE_REQUESTED:
      return {
        ...INITIAL_STATE,
        loading: true,
      };

    case LOAD_PROFILE_OK:
      return {
        ...INITIAL_STATE,
        loading: false,
        data: action.data,
        isUnknownAccountType:
          action.data[PROFILE_FIELD.ACCOUNT_TYPE] === ACCOUNT_TYPE.UNKNOWN,
        isCompany:
          action.data[PROFILE_FIELD.ACCOUNT_TYPE] === ACCOUNT_TYPE.COMPANY,
        isIndividual:
          action.data[PROFILE_FIELD.ACCOUNT_TYPE] === ACCOUNT_TYPE.INDIVIDUAL,
        isOurTermsAccepted: Boolean(
          action.data[PROFILE_FIELD.TERMS_AND_CONDITIONS_OURS_AGREED_AT]
        ),
      };

    case LOAD_PROFILE_FAIL:
      return {
        ...INITIAL_STATE,
        loading: false,
        data: undefined,
        errors: action.errors,
      };

    case UPDATE_PROFILE_REQUESTED:
      return {
        ...state,
        loading: true,
      };

    case UPDATE_PROFILE_OK:
      return {
        ...state,
        loading: false,
        isOurTermsAccepted: Boolean(
          action.data[PROFILE_FIELD.TERMS_AND_CONDITIONS_OURS_AGREED_AT]
        ),
      };

    case UPDATE_PROFILE_FAIL:
      return {
        ...state,
        loading: false,
        errors: {
          [PROFILE_FIELD.CITY]:
            action.errors.contact_info &&
            action.errors.contact_info[PROFILE_FIELD.CITY]
              ? action.errors.contact_info[PROFILE_FIELD.CITY]
              : INITIAL_STATE.errors[PROFILE_FIELD.CITY],

          [PROFILE_FIELD.ADDRESS]:
            action.errors.legal_info &&
            action.errors.legal_info[PROFILE_FIELD.ADDRESS]
              ? action.errors.legal_info[PROFILE_FIELD.ADDRESS]
              : INITIAL_STATE.errors[PROFILE_FIELD.ADDRESS],

          [PROFILE_FIELD.MESSENGER]:
            action.errors.contact_info &&
            action.errors.contact_info[PROFILE_FIELD.MESSENGER]
              ? action.errors.contact_info[PROFILE_FIELD.MESSENGER]
              : INITIAL_STATE.errors[PROFILE_FIELD.MESSENGER],

          [PROFILE_FIELD.PHONE_NUMBER]:
            action.errors.contact_info &&
            action.errors.contact_info[PROFILE_FIELD.PHONE_NUMBER]
              ? action.errors.contact_info[PROFILE_FIELD.PHONE_NUMBER]
              : INITIAL_STATE.errors[PROFILE_FIELD.PHONE_NUMBER],

          [PROFILE_FIELD.VAT]:
            action.errors.legal_info &&
            action.errors.legal_info[PROFILE_FIELD.VAT]
              ? action.errors[PROFILE_FIELD.VAT]
              : INITIAL_STATE.errors[PROFILE_FIELD.VAT],

          [PROFILE_FIELD.COMPANY_NAME]:
            action.errors.legal_info &&
            action.errors.legal_info[PROFILE_FIELD.COMPANY_NAME]
              ? action.errors[PROFILE_FIELD.COMPANY_NAME]
              : INITIAL_STATE.errors[PROFILE_FIELD.COMPANY_NAME],

          [PROFILE_FIELD.FIRST_NAME]:
              action.errors.legal_info &&
              action.errors.legal_info[PROFILE_FIELD.FIRST_NAME]
                  ? action.errors.legal_info[PROFILE_FIELD.FIRST_NAME]
                  : INITIAL_STATE.errors[PROFILE_FIELD.FIRST_NAME],

          [PROFILE_FIELD.LAST_NAME]:
              action.errors.legal_info &&
              action.errors.legal_info[PROFILE_FIELD.LAST_NAME]
                  ? action.errors.legal_info[PROFILE_FIELD.LAST_NAME]
                  : INITIAL_STATE.errors[PROFILE_FIELD.LAST_NAME],
        },
      };

    case SET_PROFILE:
      return {
        ...state,
        data: {
          ...state.data,
          ...action.data,
        },
        errors: INITIAL_STATE.errors,
      };

    case SET_ACCOUNT_TYPE:
      return {
        ...state,
        data: {
          ...state.data,
          ...action.data,
        },
        isCompany:
          action.data[PROFILE_FIELD.ACCOUNT_TYPE] === ACCOUNT_TYPE.COMPANY,
        isIndividual:
          action.data[PROFILE_FIELD.ACCOUNT_TYPE] === ACCOUNT_TYPE.INDIVIDUAL,
      };

    case SET_CURRENT_PASSWORD:
      return {
        ...state,
        currentPassword: action.data.currentPassword,
        passwordErrors: INITIAL_STATE.passwordErrors,
      };

    case SET_NEW_PASSWORD:
      return {
        ...state,
        newPassword: action.data.password,
        passwordErrors: INITIAL_STATE.passwordErrors,
      };

    case SET_NEW_CONFIRM_PASSWORD:
      return {
        ...state,
        newConfirmPassword: action.data.confirmPassword,
        passwordErrors: INITIAL_STATE.passwordErrors,
      };

    case UPDATE_PASSWORD_REQUESTED:
      return {
        ...state,
      };

    case UPDATE_PASSWORD_OK:
      return {
        ...state,
        passwordErrors: INITIAL_STATE.passwordErrors,
        [PASSWORD.CURRENT_PASSWORD]: "",
        [PASSWORD.NEW_PASSWORD]: "",
        [PASSWORD.NEW_CONFIRM_PASSWORD]: "",
        isPasswordUpdated: true,
      };

    case UPDATE_PASSWORD_FAIL:
      return {
        ...state,
        passwordErrors: {
          [PASSWORD.CURRENT_PASSWORD]: action.errors[PASSWORD.CURRENT_PASSWORD]
            ? action.errors[PASSWORD.CURRENT_PASSWORD]
            : INITIAL_STATE.passwordErrors[PASSWORD.CURRENT_PASSWORD],
          [PASSWORD.NEW_PASSWORD]:
            action.errors.password &&
            action.errors.password[PASSWORD.NEW_PASSWORD]
              ? action.errors.password[PASSWORD.NEW_PASSWORD]
              : INITIAL_STATE.passwordErrors[PASSWORD.NEW_PASSWORD],
          [PASSWORD.NEW_CONFIRM_PASSWORD]:
            INITIAL_STATE.passwordErrors[PASSWORD.NEW_CONFIRM_PASSWORD],
        },
        isPasswordUpdated: false,
      };

    default:
      return state;
  }
}
